import { t } from "i18next";

export const SystemDataListArray = {
	XML_VERSION_TAG: "XML_VERSION_TAG",
	TODAY: "TODAY",
	TOMORROW: "TOMORROW",
	YESTERDAY: "YESTERDAY",
	TRANSACTION_ID: "TRANSACTION_ID",
	IS_REPROCESS: "IS_REPROCESS",
	IS_PROCESS_INCOMPLETE: "IS_PROCESS_INCOMPLETE",
	IS_REALTIME: "IS_REALTIME",
	WORKFLOW_NAME: "WORKFLOW_NAME",
	WORKFLOW_GROUP_NAME: "WORKFLOW_GROUP_NAME",
	ACCOUNT_NAME: "ACCOUNT_NAME",
	IN_TEMPLATE_NAME: "IN_TEMPLATE_NAME",
	OUT_TEMPLATE_NAME: "OUT_TEMPLATE_NAME",
	GUID: "GUID",
	IS_RUNNING_IN_WORKBENCH: "IS_RUNNING_IN_WORKBENCH",
	IN_RECORD_COUNT: "IN_RECORD_COUNT",
	OUT_RECORD_COUNT: "OUT_RECORD_COUNT",
	IN_CHAR_COUNT: "IN_CHAR_COUNT",
	OUT_CHAR_COUNT: "OUT_CHAR_COUNT",
	TOTAL_OUT_CHAR_COUNT: "TOTAL_OUT_CHAR_COUNT",
	HOSTNAME: "HOSTNAME",
	IP_ADDRESS: "IP_ADDRESS",
	BRIDGEGATE_HOME: "BRIDGEGATE_HOME",
	SERVER_VERSION_BUILD: "SERVER_VERSION_BUILD",
	WFG_HOME: "WFG_HOME",
	IN_EDI_VERSION: "IN_EDI_VERSION",
	OUT_EDI_VERSION: "OUT_EDI_VERSION",
	IN_TRANS_SET: "IN_TRANS_SET",
	OUT_TRANS_SET: "OUT_TRANS_SET",
	SERVER_CONFIG_ALIAS: "SERVER_CONFIG_ALIAS",
	SERVER_CONFIG_EXTERNAL_URL: "SERVER_CONFIG_EXTERNAL_URL",
	SERVER_CONFIG_SERVER_URLS: "SERVER_CONFIG_SERVER_URLS",
	SERVER_CONFIG_SERVER_URL: "SERVER_CONFIG_SERVER_URL",
	IN_FIELD_DELIMITER: "IN_FIELD_DELIMITER",
	OUT_FIELD_DELIMITER: "OUT_FIELD_DELIMITER",
	IN_RECORD_DELIMITER: "IN_RECORD_DELIMITER",
	OUT_RECORD_DELIMITER: "OUT_RECORD_DELIMITER",
	IN_GROUP_COMP_DELIMITER: "IN_GROUP_COMP_DELIMITER",
	OUT_GROUP_COMP_DELIMITER: "OUT_GROUP_COMP_DELIMITER",
	IN_COMP_DELIMITER: "IN_COMP_DELIMITER",
	OUT_COMP_DELIMITER: "OUT_COMP_DELIMITER",
	IN_REPETITION_DELIMITER: "IN_REPETITION_DELIMITER",
	OUT_REPETITION_DELIMITER: "OUT_REPETITION_DELIMITER",
	IN_ESCAPE_DELIMITER: "IN_ESCAPE_DELIMITER",
	OUT_ESCAPE_DELIMITER: "OUT_ESCAPE_DELIMITER",
};
export const fieldTypeOptionsArray = [
	{ value: "SELECT", text: "SELECT" },
	{ value: "ALPHA", text: "ALPHA" },
	{ value: "BIT_FLAG", text: "BIT_FLAG" },
	{ value: "DATE", text: "DATE" },
	{ value: "FLOAT", text: "FLOAT" },
	{ value: "INTEGER", text: "INTEGER" },
	{ value: "PACKED_INT", text: "PACKED_INT" },
	{ value: "ZONED_INT", text: "ZONED_INT" },
];
export const outboundFieldTypeOptionsArray = [
	{ value: "SELECT", text: "SELECT" },
	{ value: "ALPHA", text: "ALPHA" },
	{ value: "CONSTANT", text: "CONSTANT"},
	{ value: "BIT_FLAG", text: "BIT_FLAG" },
	{ value: "DATE", text: "DATE" },
	{ value: "FLOAT", text: "FLOAT" },
	{ value: "INTEGER", text: "INTEGER" },
	{ value: "PACKED_INT", text: "PACKED_INT" },
	{ value: "ZONED_INT", text: "ZONED_INT" },
];

export const encodingConstant = {
	DEFAULT_ENCODING: "DEFAULT_ENCODING",
	Cp1252: "Cp1252",
	UTF_8: "UTF-8",
	UTF_16: "UTF-16",
	UTF_BIG: "UTF-16BE",
	UTF_LITTLE: "UTF-16LE",
	JISAutoDetect: "JISAutoDetect",
	ENC_OI_SJIS: "OI-Shift_JIS",
	JIS: "ISO-2022-JP",
	ENC_JIPSE: "JIPSE",
	ENC_KEIS: "KEIS",
	EUC_JP: "EUC-JP",
	ENC_IBM_JAPAN: "IBM-JAPAN",
	ENC_FUJITSU_JAPAN: "FUJITSU-JAPAN",
	Cp1047: "Cp1047",
};

/**
 * GetData adapter types that support "Enable workflow to be executed as a service".
 * Must match adapters where isServiceSupported() returns true in Java AdapterFactory.getServiceAdapterList().
 */
export const SERVICE_SUPPORTED_GETDATA_ADAPTER_TYPES = [
	'AS2',
	'FILE',
	'BridgeGateWebService',
	'BridgeGateFTP',
	'BridgeGateHTTP',
	'BridgeGateJMS',
	'BridgeGateMQSeries',
	'BridgeGateMSMQ',
	'BridgeGateSocket',
	'BridgeGateUDP',
	'Kafka',
];

export const cutomDbEncodingConstant = {
	DEFAULT_ENCODING: "DEFAULT_ENCODING",
	Cp1252: "Cp1252",
	UTF_8: "UTF-8",
	UTF_16: "UTF-16",
	UTF_BIG: "UTF-16BE",
	UTF_LITTLE: "UTF-16LE",
	ENC_OI_SJIS: "OI-Shift_JIS",
	JIS: "ISO-2022-JP",
	ENC_JIPSE: "JIPSE",
	ENC_KEIS: "KEIS",
	EUC_JP: "EUC-JP",
	ENC_IBM_JAPAN: "IBM-JAPAN",
	ENC_FUJITSU_JAPAN: "FUJITSU-JAPAN",
	Cp1047: "Cp1047",
};

export const destinationTypeOptions = [
	{ text: "QUEUE", value: "QUEUE" },
	{ text: "TOPIC", value: "TOPIC" },
];

export const authenticationTypeOptions = [
	{ text: "NONE", value: "NONE" },
	{ text: "BASIC", value: "BASIC" },
	{ text: "BRIDGEGATE", value: "BRIDGEGATE" },
];

export const TRANSPORTS = ["SELECT", "HTTP", "HTTPS"];
export const SECURITIES = ["SELECT", "SIGNED", "ENCRYPTED", "SIGNED_ENCRYPTED"];
export const MDN_TRANSPORTS = ["SELECT", "SYNCHRONOUS", "ASYNCHRONOUS"];

export const authOptions = [
	{ text: "BASIC_AUTH", value: "BASIC_AUTH" },
	{ text: "GOOGLE_OAUTH2", value: "GOOGLE_OAUTH2" },
	{ text: "OUTLOOK_OAUTH2", value: "OUTLOOK_OAUTH2" },
];
export const protocolOptions = [
	{ text: "IMAP", value: "IMAP" },
	{ text: "POP3", value: "POP3" },
	{ text: "MS_GRAPH", value: "MS_GRAPH" },
];
export const emailTypeOptions = [
	{ text: "ALL", value: "ALL" },
	{ text: "SEEN", value: "SEEN" },
	{ text: "RECENT", value: "RECENT" },
];
export const afterReadOptions = [
	{ text: "DELETED", value: "DELETED" },
	{ text: "SEEN", value: "SEEN" },
];
export const readDataOptions = [
	{ text: "FROM_BODY", value: "FROM_EMAIL" },
	{ text: "FROM_ATTACHMENT", value: "FROM_FIRST_ATTACHMENT" },
	{ text: "LBL_WRITE_ATTACHMENTS", value: "SAVE_ATTACHMENTS" },
];

export const booleanTypeOptions = [
	{ text: "TRUE", value: "TRUE" },
	{ text: "FALSE", value: "FALSE" },
];

export const autoOffsetTypeOptions = [
	{ text: "EARLIEST", value: "EARLIEST" },
	{ text: "LATEST", value: "LATEST" },
];

export const authTypeOptions = [
	{ text: "NONE", value: "NONE" },
	{ text: "SASL_PLAIN", value: "SASL_PLAIN" },
	{ text: "SSL", value: "SSL" },
];

export const queueTypeOptions = [
	{ text: "PRIVATE", value: "PRIVATE" },
	{ text: "PUBLIC", value: "PUBLIC" },
];

export const authenticationWebServiceSourceTypeOptions = [
	{ text: "NONE", value: "NONE" },
	{ text: "BASIC", value: "BASIC" },
	{ text: "KERBEROS", value: "KERBEROS" },
	{text: "WS_SECURITY", value: "WS_SECURITY"}
];

export const authenticationWebServiceDestinationTypeOptions = [
	{ text: "NONE", value: "NONE" },
	{ text: "BASIC", value: "BASIC" },
	{ text: "KERBEROS", value: "KERBEROS" },
	{ text: "WS_SECURITY", value: "WS_SECURITY" },
];

export const cipherSuiteOptions = [
	{ text: "SSL_RSA_WITH_NULL_MD5", value: "SSL_RSA_WITH_NULL_MD5" },
	{ text: "SSL_RSA_WITH_NULL_SHA", value: "SSL_RSA_WITH_NULL_SHA" },
	{
		text: "SSL_RSA_EXPORT_WITH_RC4_40_MD5",
		value: "SSL_RSA_EXPORT_WITH_RC4_40_MD5",
	},
	{ text: "SSL_RSA_WITH_RC4_128_MD5", value: "SSL_RSA_WITH_RC4_128_MD5" },
	{ text: "SSL_RSA_WITH_RC4_128_SHA", value: "SSL_RSA_WITH_RC4_128_SHA" },
	{
		text: "SSL_RSA_WITH_AES_128_CBC_SHA",
		value: "SSL_RSA_WITH_AES_128_CBC_SHA",
	},
	{
		text: "SSL_RSA_WITH_AES_256_CBC_SHA",
		value: "SSL_RSA_WITH_AES_256_CBC_SHA",
	},
	{
		text: "SSL_RSA_WITH_3DES_EDE_CBC_SHA",
		value: "SSL_RSA_WITH_3DES_EDE_CBC_SHA",
	},
	{ text: "SSL_RSA_WITH_DES_CBC_SHA", value: "SSL_RSA_WITH_DES_CBC_SHA" },
	{ text: "*TLS12ORHIGHER", value: "*TLS12ORHIGHER" },
	{
		text: "TLS_RSA_WITH_AES_128_CBC_SHA",
		value: "TLS_RSA_WITH_AES_128_CBC_SHA",
	},
	{ text: "TLS_AES_128_GCM_SHA256", value: "TLS_AES_128_GCM_SHA256" },
];

export const requestTypeOptions = [
	{ text: "DELETE", value: "DELETE" },
	{ text: "GET", value: "GET" },
	{ text: "HEAD", value: "HEAD" },
	{ text: "OPTIONS", value: "OPTIONS" },
	{ text: "PATCH", value: "PATCH" },
	{ text: "POST", value: "POST" },
	{ text: "PUT", value: "PUT" },
];

export const contentTypeOptions = [
	"multipart/form-data",
	"application/x-www-form-urlencoded",
	"text/xml: charset=utf-8",
	"application/json",
	"json-patch+json",
	"application/json-merge-patch",
	"application/octet-stream"
];
export const graphQLContentTypeOptions = [
	"application/json",
	"application/x-www-form-urlencoded",
	"multipart/form-data",
];

export const findByTypes = [
	"ActiveMQ",
	"AmazonSQS",
	"AS2",
	"Azure",
	"BridgeGateWebService",
	"BridgeGateFTP",
	"BridgeGateMQSeries",
	"BridgeGateMSMQ",
	"BridgeGateSocket",
	"Command_Prompt",
	"DATABASE",
	"EMAIL",
	"FILE",
	"FTP",
	"HTTP",
	"JMS",
	"Kafka",
	"MQ_Series",
	"MSMQ",
	"SOCKET",
	"BTN_SSH",
	"Web_Service",
];

export const PORTIONING_LIST = [
	"NONE",
	"BTN_EXACT_PORTIONING",
	"BTN_REL_PORTIONING",
	"BTN_XPATH",
	"BTN_JSON_PATH",
	"MNU_ITEM_REGEX"
];
export const MASKS = ["MASK_PHONE", "MASK_SSN", "MASK_ZIP", "MASK_ZIP_PLUS4"];
export const CONVERSION_LIST = [{ value: "ABS", text: "ABS" }];
export const fromExactDropdowns = [
	{ value: "LEFT", text: "LEFT" },
	{ value: "RIGHT", text: "RIGHT" },
];

export const repetitionDropdown = [
	{ value: "CURRENT", text: t("CURRENT") },
	{ value: "FIRST", text: t("FIRST") },
	{ value: "LAST", text: t("LAST") },
	{ value: "ALL_AS_STRING", text: t("ALL_AS_STRING") },
];

export const operatorsDropdowns = [
	{ value: "EMPTY", text: t("EMPTY") },
	{ value: "EQUALS", text: t("EQUALS") },
	{ value: "CONTAINS", text: t("CONTAINS") },
	{ value: "STARTS_WITH", text: t("STARTS WITH") },
	{ value: "ENDS_WITH", text: t("ENDS WITH") },
	{ value: "GREATER_THAN", text: t("GREATER THAN") },
	{ value: "LESS_THAN", text: t("LESS THAN") },
	{ value: "GREATER_THAN_OR_EQUAL", text: t("GREATER THAN OR EQUAL") },
	{ value: "LESS_THAN_OR_EQUAL", text: t("LESS THAN OR EQUAL") },
	{ value: "IS_RECORD_NUMBER", text: t("IS RECORD NUMBER") },
	{ value: "IS_NUMERIC", text: t("IS NUMERIC") },
	{ value: "IS_DATE", text: t("IS DATE") },
	{ value: "FIELD_LENGTH_GREATER_THAN", text: t("FIELD LENGTH GREATER THAN") },
	{ value: "FIELD_LENGTH_LESS_THAN", text: t("FIELD LENGTH LESS THAN") },
	{ value: "REGULAR_EXPRESSION", text: t("REGULAR EXPRESSION") },
	{ value: "TRUE", text: t("TRUE") },
	{ value: "FALSE", text: t("FALSE") }
];

export const workflowOperatorsDropDown = [
	{ value: "ISNULL", text: t("EMPTY") },
	{ value: "EQUALS", text: t("EQUALS") },
	{ value: "CONTAINS", text: t("CONTAINS") },
	{ value: "STARTS_WITH", text: t("STARTS WITH") },
	{ value: "ENDS_WITH", text: t("ENDS WITH") },
	{ value: "GREATER_THAN", text: t("GREATER THAN") },
	{ value: "LESS_THAN", text: t("LESS THAN") },
	{ value: "GREATER_THAN_OR_EQUAL", text: t("GREATER THAN OR EQUAL") },
	{ value: "LESS_THAN_OR_EQUAL", text: t("LESS THAN OR EQUAL") },
	{ value: "IS_RECORD_NUMBER", text: t("IS RECORD NUMBER") },
	{ value: "IS_NUMERIC", text: t("IS NUMERIC") },
	{ value: "IS_DATE", text: t("IS DATE") },
	{ value: "FIELD_LENGTH_GREATER_THAN", text: t("FIELD LENGTH GREATER THAN") },
	{ value: "FIELD_LENGTH_LESS_THAN", text: t("FIELD LENGTH LESS THAN") },
	{ value: "REGULAR_EXPRESSION", text: t("REGULAR EXPRESSION") },
	{ value: "TRUE", text: t("TRUE") },
	{ value: "FALSE", text: t("FALSE") }
];

export const variableActionList = [
	{
		value: "COUNT",
		text: "COUNT",
	},
	{
		value: "CONVERT_TO_FIELD_TYPE",
		text: "CONVERT_TO_FIELD_TYPE",
	},
	{
		value: "SET",
		text: "SET",
	},
	{
		value: "RESET",
		text: "RESET",
	},
	{
		value: "CONCATENATE",
		text: "CONCATENATE",
	},
	{
		value: "ADD",
		text: "ADD",
	},
	{
		value: "SUBTRACT",
		text: "SUBTRACT",
	},
	{
		value: "MULTIPLY",
		text: "MULTIPLY",
	},
	{
		value: "DIVIDE",
		text: "DIVIDE",
	},
	// {
	// 	value: "SORT",
	// 	text: "SORT",
	// },
	// {
	// 	value: "SORT_UNIQUE",
	// 	text: "SORT_UNIQUE",
	// },
	// {
	// 	value: "UNIQUE",
	// 	text: "UNIQUE",
	// },
	// {
	// 	value: "REVERSE",
	// 	text: "REVERSE",
	// },
	{
		value: "ABS",
		text: "ABS",
	},
	{
		value: "ACOS",
		text: "ACOS",
	},
	{
		value: "ACRE_TO_HECTARE",
		text: "ACRE_TO_HECTARE",
	},
	{
		value: "DATE_DIFF",
		text: "DATE_DIFF",
	},
	{
		value: "ACRE_TO_SQMETER",
		text: "ACRE_TO_SQMETER",
	},
	{
		value: "ASCII_TO_ENCODE_HEX",
		text: "ASCII_TO_ENCODE_HEX",
	},
	{
		value: "ASIN",
		text: "ASIN",
	},
	{
		value: "BASE64_TO_STRING",
		text: "BASE64_TO_STRING",
	},
	{
		value: "BASE64URL_TO_STRING",
		text: "BASE64URL_TO_STRING",
	},
	{
		value: "CEILING",
		text: "CEILING",
	},
	{
		value: "CELSIUS_TO_FAHRENHEIT",
		text: "CELSIUS_TO_FAHRENHEIT",
	},
	{
		value: "CENTIMETER_TO_INCHES",
		text: "CENTIMETER_TO_INCHES",
	},
	{
		value: "CHAR",
		text: "CHAR",
	},
	{
		value: "COS",
		text: "COS",
	},
	{
		value: "CUBICFEET_TO_CUBICMETER",
		text: "CUBICFEET_TO_CUBICMETER",
	},
	{
		value: "CUBICINCHES_TO_LITERS",
		text: "CUBICINCHES_TO_LITERS",
	},
	{
		value: "CUBICMETER_TO_CUBICFEET",
		text: "CUBICMETER_TO_CUBICFEET",
	},
	{
		value: "CUBICMETER_TO_CUBICYARD",
		text: "CUBICMETER_TO_CUBICYARD",
	},
	{
		value: "CUBICMETER_TO_GALLON",
		text: "CUBICMETER_TO_GALLON",
	},
	{
		value: "CUBICYARD_TO_CUBICMETER",
		text: "CUBICYARD_TO_CUBICMETER",
	},
	{
		value: "ENCODE_HEX_TO_ASCII",
		text: "ENCODE_HEX_TO_ASCII",
	},
	{
		value: "ESCAPE_XML_DATA",
		text: "ESCAPE_XML_DATA",
	},
	{
		value: "FAHRENHEIT_TO_CELSIUS",
		text: "FAHRENHEIT_TO_CELSIUS",
	},
	{
		value: "FEET_TO_METERS",
		text: "FEET_TO_METERS",
	},
	{
		value: "FLOOR",
		text: "FLOOR",
	},
	{
		value: "GALLON_TO_CUBICMETER",
		text: "GALLON_TO_CUBICMETER",
	},
	{
		value: "GRAMS_TO_OUNCES",
		text: "GRAMS_TO_OUNCES",
	},
	{
		value: "HECTARE_TO_ACRE",
		text: "HECTARE_TO_ACRE",
	},
	{
		value: "HEXADECIMAL",
		text: "HEXADECIMAL",
	},
	{
		value: "HEX_TO_DECIMAL",
		text: "HEX_TO_DECIMAL",
	},
	{
		value: "INCHES_TO_CENTIMETER",
		text: "INCHES_TO_CENTIMETER",
	},
	{
		value: "INCHES_TO_MM",
		text: "INCHES_TO_MM",
	},
	{
		value: "KG_TO_LBS",
		text: "KG_TO_LBS",
	},
	{
		value: "KM_TO_MILES",
		text: "KM_TO_MILES",
	},
	{
		value: "LBS_TO_KG",
		text: "LBS_TO_KG",
	},
	{
		value: "LITERS_TO_CUBICINCHES",
		text: "LITERS_TO_CUBICINCHES",
	},
	{
		value: "LITERS_TO_QUARTS",
		text: "LITERS_TO_QUARTS",
	},
	{
		value: "LOG",
		text: "LOG",
	},
	{
		value: "LOG_10",
		text: "LOG_10",
	},
	{
		value: "METERS_TO_FEET",
		text: "METERS_TO_FEET",
	},
	{
		value: "METERS_TO_YARDS",
		text: "METERS_TO_YARDS",
	},
	{
		value: "MM_TO_INCHES",
		text: "MM_TO_INCHES",
	},
	{
		value: "MILES_TO_KM",
		text: "MILES_TO_KM",
	},
	{
		value: "MODULUS",
		text: "MODULUS",
	},
	{
		value: "OUNCES_TO_GRAMS",
		text: "OUNCES_TO_GRAMS",
	},
	{
		value: "OCTAL",
		text: "OCTAL",
	},
	{
		value: "POWER",
		text: "POWER",
	},
	{
		value: "RAND",
		text: "RAND",
	},
	{
		value: "HASH_SHA_1",
		text: "HASH_SHA_1",
	},
	{
		value: "HASH_SHA_224",
		text: "HASH_SHA_224",
	},
	{
		value: "HASH_SHA_256",
		text: "HASH_SHA_256",
	},
	{
		value: "HASH_SHA_384",
		text: "HASH_SHA_384",
	},
	{
		value: "HASH_SHA_512",
		text: "HASH_SHA_512",
	},
	{
		value: "HASH_MD5",
		text: "HASH_MD5",
	},
	{
		value: "QUARTS_TO_LITERS",
		text: "QUARTS_TO_LITERS",
	},
	{
		value: "ROUND",
		text: "ROUND",
	},
	{
		value: "ROUND_DOWN",
		text: "ROUND_DOWN",
	},
	{
		value: "ROUND_UP",
		text: "ROUND_UP",
	},
	{
		value: "SIGN",
		text: "SIGN",
	},
	{
		value: "SIN",
		text: "SIN",
	},
	{
		value: "SQCENTIMETER_TO_SQINCHES",
		text: "SQCENTIMETER_TO_SQINCHES",
	},
	{
		value: "SQFEET_TO_SQMETER",
		text: "SQFEET_TO_SQMETER",
	},
	{
		value: "SQINCHES_TO_SQCENTIMETER",
		text: "SQINCHES_TO_SQCENTIMETER",
	},
	{
		value: "SQMETER_TO_ACRE",
		text: "SQMETER_TO_ACRE",
	},
	{
		value: "SQMETERS_TO_SQYARDS",
		text: "SQMETERS_TO_SQYARDS",
	},
	{
		value: "SQMETER_TO_SQFEET",
		text: "SQMETER_TO_SQFEET",
	},
	{
		value: "SQRT",
		text: "SQRT",
	},
	{
		value: "SQYARDS_TO_SQMETERS",
		text: "SQYARDS_TO_SQMETERS",
	},
	{
		value: "STRING_LENGTH",
		text: "STRING_LENGTH",
	},
	{
		value: "STRING_TO_BASE64",
		text: "STRING_TO_BASE64",
	},
	{
		value: "STRING_TO_BASE64URL",
		text: "STRING_TO_BASE64URL",
	},
	{
		value: "SUBSTRING_COUNT",
		text: "SUBSTRING_COUNT",
	},
	{
		value: "TAN",
		text: "TAN",
	},
	{
		value: "TANH",
		text: "TANH",
	},
	{
		value: "TO_DEGREE",
		text: "TO_DEGREE",
	},
	{
		value: "TO_RADIAN",
		text: "TO_RADIAN",
	},
	{
		value: "YARDS_TO_METERS",
		text: "YARDS_TO_METERS",
	},
	{
		value: "URLENCODE",
		text: "URLENCODE",
	},
	{
		value: "URLDECODE",
		text: "URLDECODE",
	},
	{
		value: "XML_TO_JSON",
		text: "XML_TO_JSON",
	},
	{
		value: "IS_VALID_XML",
		text: "IS_VALID_XML",
	},
	{
		value: "PRETTY_PRINT_XML",
		text: "PRETTY_PRINT_XML",
	},
	{
		value: "DE_IDENTIFY",
		text: "DE_IDENTIFY",
	}
];


export const convetCaseDropDown = [
	{ value: "DO_NOT_CONVERT", text: "DO_NOT_CONVERT" },
	{ value: "UPPER_CASE", text: "UPPER_CASE" },
	{ value: "LOWER_CASE", text: "LOWER_CASE" },
	{ value: "PROPER_CASE", text: "PROPER_CASE" },
]

export const fillCharacterDropDown = [
	{ value: "SPACE", text: "SPACE" }
]

export const onErrorDropDown = [
	{ value: "TRUE", text: "KEEP_ORIGINAL_DATA" },
	{ value: "FALSE", text: "LEAVE_BLANK" }
]

export const constantValueDropDown = [
	{ value: "CRLF", text: "CRLF" },
	{ value: "%RECORD_DELIMITER%", text: "%RECORD_DELIMITER%" }
]

export const dateIntervalDropDown = [
	{ value: "SECOND", text: "SECOND" },
	{ value: "MINUTE", text: "MINUTE" },
	{ value: "HOUR", text: "HOUR" },
	{ value: "DAY", text: "DAY" },
	{ value: "WEEK", text: "WEEK" },
	{ value: "MONTH", text: "MONTH" },
	{ value: "YEAR", text: "YEAR" },
]

export const convertCaseOptionsArray = [
	{ value: 'DO_NOT_CONVERT', text: t('DO_NOT_CONVERT') },
	{ value: 'UPPER_CASE', text: t('UPPER_CASE') },
	{ value: 'LOWER_CASE', text: t('LOWER_CASE') },
	{ value: 'PROPER_CASE', text: t('PROPER_CASE') }
];

export const paddingDirectionArray = [
	{ value: 'RIGHT', text: t('RIGHT') },
	{ value: 'LEFT', text: t('LEFT') }
];

export const errorArray = [
	{ value: 'Keep Original Data', text: t('KEEP_ORIGINAL_DATA') },
	{ value: 'Use Default Value', text: t('LEAVE_BLANK') }
]

export const OUT_TYPES = [
	'AS2',
	'ActiveMQ',
	'AmazonSQS',
	'Azure',
	'BridgeGateFTP',
	'Command Prompt',
	'DATABASE',
	'Data Stream',
	'EMAIL',
	'FILE',
	'FTP',
	'HTTP',
	'JMS',
	'Kafka',
	'MQ Series',
	'MSMQ',
	'SOCKET',
	'SSH',
	'Web Service'
]

export const TRACKING_REPORT_DATA_TYPE = [
	{ value: "", text: "SELECT" },
	{ value: "varchar", text: "ALPHA" },
	{ value: "datetime", text: "DATE" },
	{ value: "float", text: "FLOAT" },
	{ value: "integer", text: "INTEGER" },
	{ value: "text", text: "TEXT" },
];


export const TRANSLATE_OUTBOUND_CONDITION_MAPPING_2 = [
	{ value: "SELECT", title: t("SELECT") },
	{ value: "SESSION_DATA", title: t("SESSION_DATA") },
	{ value: "SYSTEM_DATA", title: t("SYSTEM_DATA") },
	{ value: "TRADING_PARTNER_KEYS", title: t("TRADING_PARTNER_KEYS") },
	{ value: "ACCOUNT_KEYS", title: t("ACCOUNT_KEYS") },
	{ value: "CONSTANT", title: t("CONSTANT") },
	{ value: "SEG_VAL_ERR", title: t("SEG_VAL_ERR") },
	{ value: "ELEM_VAL_ERR", title: t("ELEM_VAL_ERR") },
	{ value: "TRN_SET_VAL_ERR", title: t("TRN_SET_VAL_ERR") },
	{ value: "FNCT_GRP_VAL_ERR", title: t("FNCT_GRP_VAL_ERR") },
]

export const TRANSLATE_OUTBOUND_CONDITION_MAPPING_2_SOURCE = {
	SEG_VAL_ERR: [
		{ value: "MAP_ERROR_EXIST", title: t("MAP_ERROR_EXIST") },
		{ value: "ERROR_STRING", title: t("ERROR_STRING") },
	],
	ELEM_VAL_ERR: [
		{ value: "MAP_ERROR_EXIST", title: t("MAP_ERROR_EXIST") },
		{ value: "ERROR_STRING", title: t("ERROR_STRING") },
	],
	TRN_SET_VAL_ERR: [
		{ value: "TRAN_SET_ACK_CODE", title: t("TRAN_SET_ACK_CODE") },
		{ value: "MAP_ERROR_EXIST", title: t("MAP_ERROR_EXIST") },
		{ value: "ERROR_STRING", title: t("ERROR_STRING") },
	],
	FNCT_GRP_VAL_ERR: [
		{ value: "FNCT_GRP_ACKT_CODE", title: t("FNCT_GRP_ACKT_CODE") },
		{ value: "MAP_ERROR_EXIST", title: t("MAP_ERROR_EXIST") },
		{ value: "ERROR_STRING", title: t("ERROR_STRING") },
	]
}

export const actionTypeOptions = [
	{text: 'ACTION_ROLLBACK' , value: 'ACTION_ROLLBACK'},
	{text: 'ACTION_COMMIT', value: 'ACTION_COMMIT'},
	{text: 'ACTION_CLOSE_ALL', value: 'ACTION_CLOSE_ALL'},
	{text: 'ACTION_SET_TXN_STATUS', value: 'ACTION_SET_TXN_STATUS'},
	{text: 'ACTION_STOP_WORKFLOW_PROCESSING', value: 'ACTION_STOP_WORKFLOW_PROCESSING'},
	{text: 'ACTION_DELETE_FILE', value: 'ACTION_DELETE_FILE'},
]

export const transactionStatusOptions = [
	{text: 'ERROR', value: 'ERROR'},
	{text: 'ERR_INPROGRESS', value: 'ERR_INPROGRESS'},
	{text: 'RESOLVED', value: 'RESOLVED'},
	{text: 'SUCCESS', value: 'SUCCESS'},
	{text: 'SUCCESS_NO_DATA', value: 'SUCCESS_NO_DATA'},
	{text: 'TRANS_ERRORS', value: 'TRANS_ERRORS'},
	{text: 'ACT_VAL_ERROR', value: 'VALIDATION_ERRORS'},
]


export const loopTypeOptions = [
	{ text: "SELECT", value: t("SELECT") },
	{ text: "LOOP_TYPE_LIST", value: "LOOP_TYPE_LIST" },
	{ text: "LOOP_TYPE_VALUE", value: "LOOP_TYPE_VALUE" },
	{ text: "LOOP_TYPE_CONDITION", value: "LOOP_TYPE_CONDITION" },
];

export const workflowStatusOptions = [
	{ text: "SELECT", value: "" },
	{ text: "ERROR", value: "ERROR" },
	{ text: "WF_ERROR_INPROGRESS", value: "ERR_INPROGRESS" },
	{ text: "RESOLVED", value: "RESOLVED" },
	{ text: "SUCCESS", value: "SUCCESS" },
	{ text: "SUCCESS_NO_DATA", value: "SUCCESS_NO_DATA" },
	{ text: "WF_TRANSLATION_ERROR", value: "TRANS_ERRORS" },
	{ text: "ACT_VAL_ERROR", value: "VALIDATION_ERRORS" },
];

export const compressionTypeOptions = [
	{ text: t("GZ"), value: t("GZ") },
	{ text: t("JAR"), value: t("JAR") },
	{ text: t("RAR"), value: t("RAR") },
	{ text: t("TAR"), value: t("TAR") },
	{ text: t("TGZ"), value: t("TGZ") },
	{ text: t("ZIP"), value: t("ZIP") },
]

export const typesOfQos = [
	// Retry Logic, Guaranteed Delivery
	{ text: t("SELECT"), value: t("SELECT") },
	{ text: t("LBL_RETRY_LOGIC"), value: t("LBL_RETRY_LOGIC") },
	{ text: t("LBL_GUARANTEED_DELIVERY"), value: t("LBL_GUARANTEED_DELIVERY") },
]


export const dataSourceTypeOptions = [
	{ text: t("TRANSLATED_DATA"), value: "TRANSLATED_DATA" },
	{ text: t("FORWARD_ONLY_DATA"), value: "FORWARD_ONLY_DATA" },
	{ text: t("SESSION_DATA"), value: "SESSION_DATA" },
	{ text: t("CALL_WORKFLOW_DATA"), value: "CALL_WORKFLOW_DATA" },
	{ text: t("STATIC_DATA"), value: "STATIC_DATA" },
	{ text: t("LOCAL_FILE_SYSTEM"), value: "LOCAL_FILE_SYSTEM" },
];

// HTTP Status Codes (from HTTPConstants.STATUS_CODES)
export const httpStatusCodes = [
	"100 Continue",
	"101 Switching Protocols",
	"200 OK",
	"201 Created",
	"202 Accepted",
	"203 Non-Authoritative Information",
	"204 No Content",
	"205 Reset Content",
	"206 Partial Content",
	"226 IM Used",
	"300 Multiple Choices",
	"301 Moved Permanently",
	"302 Found",
	"303 See Other",
	"304 Not Modified",
	"305 Use Proxy",
	"307 Temporary Redirect",
	"400 Bad Request",
	"401 Unauthorized",
	"402 Payment Required",
	"403 Forbidden",
	"404 Not Found",
	"405 Method Not Allowed",
	"406 Not Acceptable",
	"407 Proxy Authentication Required",
	"408 Request Timeout",
	"409 Conflict",
	"410 Gone",
	"411 Length Required",
	"412 Precondition Failed",
	"413 Request Entity Too Large",
	"414 Request-URI Too Long",
	"415 Unsupported Media Type",
	"416 Requested Range Not Satisfiable",
	"417 Expectation Failed",
	"418 I'm a teapot",
	"426 Upgrade Required",
	"428 Precondition Required",
	"429 Too Many Requests",
	"431 Request Header Fields Too Large",
	"451 Unavailable For Legal Reasons",
	"500 Internal Server Error",
	"501 Not Implemented",
	"502 Bad Gateway",
	"503 Service Unavailable",
	"504 Gateway Timeout",
	"505 HTTP Version Not Supported",
	"510 Not Extended",
	"511 Network Authentication Required",
	"598 Network read timeout error",
	"599 Network connect timeout error"
];

export const definedHeaderFields = [
	{ key: 'CCSID', label: 'CCSID' },
	{ key: 'REPLYTO_QUEUENAME', label: 'REPLYTO_QUEUENAME' },
	{ key: 'MQ_ENCODING', label: 'MQ_ENCODING' },
	{ key: 'REPLYTO_QUEUEMANAGERNAME', label: 'REPLYTO_QUEUEMANAGERNAME' },
	{ key: 'EXPIRY', label: 'EXPIRY' },
	{ key: 'USER_ID', label: 'USER_ID' },
	{ key: 'PERSISTENCE', label: 'PERSISTENCE' },
	{ key: 'ACCOUNTING_TOKEN', label: 'ACCOUNTING_TOKEN' },
	{ key: 'PRIORITY', label: 'PRIORITY' },
	{ key: 'APPLICATION_ID_DATA', label: 'APPLICATION_ID_DATA' },
	{ key: 'TARGET_CLIENT', label: 'TARGET_CLIENT' },
	{ key: 'PUT_APPLICATION_NAME', label: 'PUT_APPLICATION_NAME' },
	{ key: 'VERSION', label: 'VERSION' },
	{ key: 'PUT_DATE_TIME', label: 'PUT_DATE_TIME' },
	{ key: 'REPORT', label: 'REPORT' },
	{ key: 'APPLICATION_ORIGIN_DATA', label: 'APPLICATION_ORIGIN_DATA' },
	{ key: 'MESSAGE_TYPE', label: 'MESSAGE_TYPE' },
	{ key: 'GROUP_ID', label: 'GROUP_ID' },
	{ key: 'FEEDBACK', label: 'FEEDBACK' },
	{ key: 'MESSAGE_SEQ_NUM', label: 'MESSAGE_SEQ_NUM' },
	{ key: 'FORMAT', label: 'FORMAT' },
	{ key: 'OFFSET', label: 'OFFSET' },
	{ key: 'BACKOUT_COUNT', label: 'BACKOUT_COUNT' },
	{ key: 'MESSAGE_FLAGS', label: 'MESSAGE_FLAGS' },
	{ key: 'ORIGINAL_LENGTH', label: 'ORIGINAL_LENGTH' },
	{ key: 'CORRELATION_ID', label: 'CORRELATION_ID', hex: true },
	{ key: 'MESSAGE_ID', label: 'MESSAGE_ID_LBL', hex: true },
  ];

  export const messageSelectorOperatorsDropDown = [
	{ value: "SELECT", text: t("SELECT") },
	{ value: "ISNULL", text: t("EMPTY") },
	{ value: "EQUALS", text: t("EQUALS") },
	{ value: "CONTAINS", text: t("CONTAINS") },
	{ value: "STARTS_WITH", text: t("STARTS WITH") },
	{ value: "ENDS_WITH", text: t("ENDS WITH") },
	{ value: "GREATER_THAN", text: t("GREATER THAN") },
	{ value: "LESS_THAN", text: t("LESS THAN") },
];